import RegionsCardView from './RegionsCard.view';
export default RegionsCardView;
